// src/pages/Contact.js 
// (Assuming this file contains your Contact component, not App.js, based on the function name)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; 
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import ContactComponent from './PageComponent/ContactComponent';

function Contact() {

  // 1. Remove the useMeta hook call:
  /*
  useMeta({
    title: 'Connect to our consultant now for your Blinds requirements',
    description: 'Create customized blinds as per your desire & Interior Design demands. Contact now for wide range of design, texture, visibility and openness',
    // ... rest of the meta data
  });
  */

  return (
    // 2. Wrap the JSX content in a React Fragment (<>...</>) 
    //    and place the Helmet component at the top.
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Connect to our consultant now for your Blinds requirements</title>
        <meta
          name="description"
          content="Create customized blinds as per your desire & Interior Design demands. Contact now for wide range of design, texture, visibility and openness"
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/contact/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Contact" />
        <meta
          property="og:description"
          content="Create customized blinds as per your desire & Interior Design demands. Contact now for wide range of design, texture, visibility and openness"
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/contact/`} />
        <meta property="og:site_name" content="Marvel Blinds" />
      </Helmet>

      {/* Rest of your component structure */}
      <div>
        <Navbar />
        <NotificationBar />
        <ContactComponent />
        <Footer />
      </div>
    </>
  );
}

export default Contact;